import { UserRole } from "~/__generated__/graphql"
import { UsersTable } from "./users-table"

export function AdminUsersScreen() {
  return (
    <UsersTable
      title="Users"
      description="Find or search users within this page."
      userRole={UserRole.Default}
      placeholder="Search Users"
    />
  )
}
